import GA4Utilities from './utils/ga4-utilities';
import SiteUtilities from './utils/site-utilities';

const init = () => {
  const fciScriptViaCMS = document.querySelector('[data-fci=true]');
  const chatIcon = document.getElementById('fchat-custom-icon');
  const loadingIcon = document.getElementById('fci-loading');
  if (!chatIcon || !loadingIcon) return;
  let isLoaded = false;
  let isTriggered = false;

  const fciWidgetOpen = () => {
    if (!isLoaded && (!window.fcWidget || !window.fcWidget.isLoaded())) {
      chatIcon.style.pointerEvents = 'none';
      loadingIcon.style.display = 'block';
      isTriggered = true;
    } else {
      window.fcWidget.open();
    }
  };

  const configInit = (properties) => {
    window.fcWidgetMessengerConfig = {
      config: {
        eagerLoad: true,
        headerProperty: {
          hideChatButton: true
        }
      },
      onLoad: () => eventSettings(properties)
    };
  };

  const widgetOnLoaded = (properties) => {
    const { onLoad } = properties || {};
    if (typeof onLoad === 'function') {
      onLoad();
    }
    loadingIcon.style.display = 'none';
    chatIcon.style.pointerEvents = 'auto';
    isLoaded = true;
    if (isTriggered && !window.fcWidget.isOpen()) window.fcWidget.open();
    isTriggered = false;
  };

  const eventSettings = (properties) => {
    if (window.fcWidget.isLoaded()) {
      widgetOnLoaded(properties);
    } else {
      window.fcWidget.on('widget:loaded', () => widgetOnLoaded(properties));
    }

    window.fcWidget.on('widget:opened', () => {
      chatIcon.style.display = 'none';
      GA4Utilities.freshchatEvents('chat_open');
    });
    window.fcWidget.on('widget:closed', () => {
      chatIcon.style.display = 'block';
      GA4Utilities.freshchatEvents('chat_close');
    });
    window.fcWidget.on('unreadCount:notify', (resp) => {
      if (resp && (resp.count > 0)) GA4Utilities.freshchatEvents('message_received');
    });
  };

  const eventInit = () => {
    if (!window.fcWidget) {
      window.fcSettings = {
        onInit: eventSettings
      };
    } else {
      eventSettings();
    }
  };

  const showBtn = () => {
    window.fciWidgetOpen = fciWidgetOpen;
    chatIcon.addEventListener('keypress', function (event) {
      const isEnter = SiteUtilities.keyTriggered(event, 'ENTER');
      if (isEnter) {
        event.preventDefault();
        chatIcon.click();
      }
    });
    chatIcon.style.display = 'block';
  };

  const fchatViaCmsInit = (properties) => {
    configInit(properties);
    showBtn();
  };

  const fchatViaGtmInit = () => {
    eventInit();
    showBtn();
  };

  if (fciScriptViaCMS) {
    fchatViaCmsInit();
  } else {
    window.fciViaGtmInit = fchatViaGtmInit;
    window.fciViaGtmV2Init = fchatViaCmsInit;
  }
};

export {
  init as fchatCustomIconInit
};
